import env from '../helpers/env';

// @todo can we test for these?

export default () => ['Firefox', 'Samsung', 'Safari', 'Edge', 'Chrome', 'Opera', 'iOS_WebView', 'Android_WebView'].indexOf(env.name) > -1;
